import { Alert } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import * as React from "react";
import { useTranslation } from "react-i18next";

export function OfflineNotification() {
  const { t } = useTranslation();
  const [isOffline, setIsOffline] = React.useState(!navigator.onLine);

  React.useEffect(() => {
    const update = () => setIsOffline(!navigator.onLine);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);

  if (!isOffline) {
    return null;
  }

  return (
    <Alert
      color="yellow"
      title={t("offline.title")}
      icon={<IconAlertTriangle size={18} />}
      mb="md"
    >
      {t("offline.message")}
    </Alert>
  );
}
